<div class="main-content mb-4 mx-lg-4 mx-md-4 mx-sm-0 px-sm-4 px-3">
    <ms-page-title />

    <!-- Page Header -->
    <div class="page-title-wrapper">
        
        <ms-stripe-setup-notice />

        <div class="d-flex justify-content-between flex-row flex-wrap gap-3">

            <div>
                <!-- Search Input Group -->
                <div class="input-group position-relative">
                    <input id="search" type="text" class="form-control form-control-solid ps-13 pe-5"
                        placeholder="Search Invoice Schedules" aria-label="Search Invoice Schedules"
                        [ngModel]="userSessionService.propertyChargeSchedulesFilter.searchTerm"
                        (ngModelChange)="userSessionService.propertyChargeSchedulesFilter.searchTerm = $event"
                        (keyup.enter)="loadPropertyChargeSchedules(false)" aria-describedby="search-description">

                    @if (userSessionService.propertyChargeSchedulesFilter.searchTerm) {
                    <button
                        class="btn btn-link position-absolute top-50 translate-middle-y p-0 border-0 bg-transparent mx-2 input-group-clear-button"
                        type="button" (click)="clearSearch()" aria-label="Clear search">
                        <fa-duotone-icon icon="xmark" class="text-secondary fs-6" secondaryOpacity="0.9" size="lg" />
                    </button>
                    }

                    <div class="input-group-append">
                        <button class="btn btn-primary rounded-0 rounded-end" type="button"
                            (click)="loadPropertyChargeSchedules(false)" id="button-addon2">
                            Search
                        </button>
                    </div>
                </div>
                <!-- Search Input Group -->
                <div id="search-description" class="ps-2 mt-2 text-muted small fst-italic">
                    Search by name, property title, lot number, or address
                </div>
            </div>

            <div class="d-flex gap-3">
                <ms-property-charge-schedule-search-filter
                    (filterApplied)="filterApplied()"></ms-property-charge-schedule-search-filter>

                <ms-sort-dropdown [sortOptions]="sortOptions" [(selectedSortOption)]="orderBy"
                    (selectedSortOptionChange)="setSortOrder($event)"></ms-sort-dropdown>

                <div class="dropdown" [msCloseMenuOnSettle]="isDownloading()">
                    <button class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                        aria-expanded="false">
                        <span>List Actions</span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                        <li>
                            <a class="dropdown-item" [disableWithoutPermission]="{
                                requiredPermissions: [BalancesPermissions.CreateChargeSchedules],
                                userPermissionOnly: false
                                }"
                                [routerLink]="['/invoice-schedules/create']">
                                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" class="me-2" />Create Invoice Schedule
                            </a>
                        </li>
                        <li><hr class="dropdown-divider"></li>
                        <li [msTooltip]="downloadTooltip"
                            [msTooltipDisabled]="hasSchedulesSelected() || isDownloading()"
                            [msTooltipPlacement]="TooltipPlacement.Left">
                            <a class="dropdown-item"
                                [class.disabled]="!hasSchedulesSelected() || isAnyDownloadInProgress()"
                                [attr.aria-disabled]="!hasSchedulesSelected() || isAnyDownloadInProgress()"
                                [attr.tabindex]="!hasSchedulesSelected() || isAnyDownloadInProgress() ? -1 : null"
                                msDebounceClick
                                (msDebounceClick)="$event.stopPropagation();
                                    (!hasSchedulesSelected() || isAnyDownloadInProgress())
                                        ? null : downloadFilteredInvoiceData()"
                                [disableWithoutPermission]="{
                                    requiredPermissions: [],
                                    userPermissionOnly: false
                                }">
                                @if (isDownloading()) {
                                    <span class="spinner-border spinner-border-sm me-2" role="status" aria-label="Downloading"></span>
                                } @else {
                                    <fa-duotone-icon icon="download" secondaryOpacity="0.9" class="me-2" />
                                }
                                Download Filtered Invoice Data
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div>
        <div class="d-flex flex-wrap">
            <div class="mb-0 text-start flex-grow-0 w-50" #jumpToElementMobile>
                Showing: {{propertyChargeScheduleList().length}} of {{totalCount | number}}
                <div class="badge bg-primary ms-0 ms-sm-2">
                    Selected: {{selectedCount() | number}}
                </div>
            </div>
            <div class="flex-grow-1 text-end d-block d-sm-none">
                <button id="toggleAllMobile" type="button" class="btn btn-ms-secondary text-start"
                    (click)="toggleSelectAll()">
                    <fa-duotone-icon icon="square-check" secondaryOpacity="0.2" size="lg" [hidden]="!isSelectAll" />
                    <fa-duotone-icon icon="square" secondaryOpacity="0.2" size="lg" [hidden]="isSelectAll" />
                    {{ (isSelectAll) ? 'Deselect All' : 'Select All' }}
                </button>
            </div>
        </div>

        <!-- Table Start -->
        <div class="table-responsive d-none d-sm-block">
            <table msResponsiveTable class="table table-hover fixed-header placeholder-glow">
                <thead #jumpToElement>
                    <tr>
                        <th msResponsiveTableColumn="checkbox" [priority]="1" scope="col">
                            <input id="toggleAllSelection" name="toggleAllSelection" type="checkbox"
                                class="form-check-input fs-6" [checked]="isSelectAll" (change)="toggleSelectAll()" />
                        </th>
                        <th msResponsiveTableColumn="name" [priority]="1" scope="col" class="sortable" (click)="toggleSortDirection('Name')">
                            Name
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="(orderBy == PropertyChargeScheduleListSortOptions.NameAsc) ? '0.9' : '0.3' "
                                [secondaryOpacity]="(orderBy == PropertyChargeScheduleListSortOptions.NameDesc) ? '0.9' : '0.3' " />
                        </th>
                        <th msResponsiveTableColumn="properties" [priority]="3" scope="col" class="sortable numeric-column" (click)="toggleSortDirection('Properties Count')">
                            Properties
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == PropertyChargeScheduleListSortOptions.PropertyCountAsc ? '0.9' : '0.3' "
                                [secondaryOpacity]="orderBy == PropertyChargeScheduleListSortOptions.PropertyCountDesc ? '0.9' : '0.3' " />
                        </th>
                        <th msResponsiveTableColumn="amount" [priority]="2" scope="col" class="sortable numeric-column" (click)="toggleSortDirection('Scheduled Amount')">
                            Amount
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == PropertyChargeScheduleListSortOptions.ScheduledAmountAsc ? '0.9' : '0.3' "
                                [secondaryOpacity]="orderBy == PropertyChargeScheduleListSortOptions.ScheduledAmountDesc ? '0.9' : '0.3' " />
                        </th>
                        <th msResponsiveTableColumn="frequency" [priority]="4" scope="col" class="sortable" (click)="toggleSortDirection('Frequency')">
                            Frequency
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == PropertyChargeScheduleListSortOptions.FrequencyAsc ? '0.9' : '0.3' "
                                [secondaryOpacity]="orderBy == PropertyChargeScheduleListSortOptions.FrequencyDesc ? '0.9' : '0.3' " />
                        </th>
                        <th msResponsiveTableColumn="lateInvoices" [priority]="5" scope="col" class="sortable numeric-column" (click)="toggleSortDirection('Late Charges')">
                            Late Invoices
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == PropertyChargeScheduleListSortOptions.LateChargesAsc ? '0.9' : '0.3' "
                                [secondaryOpacity]="orderBy == PropertyChargeScheduleListSortOptions.LateChargesDesc ? '0.9' : '0.3' " />
                        </th>
                        <th msResponsiveTableColumn="chargeStatus" [priority]="6" scope="col" class="sortable" (click)="toggleSortDirection('Status')">
                            Charge Status
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == PropertyChargeScheduleListSortOptions.StatusAsc ? '0.9' : '0.3' "
                                [secondaryOpacity]="orderBy == PropertyChargeScheduleListSortOptions.StatusDesc ? '0.9' : '0.3' " />
                        </th>
                        <th msResponsiveTableColumn="modified" [priority]="7" scope="col" class="sortable" (click)="toggleSortDirection('Modified')">
                            Modified
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == PropertyChargeScheduleListSortOptions.LastModifiedAsc ? '0.9' : '0.3'"
                                [secondaryOpacity]="orderBy == PropertyChargeScheduleListSortOptions.LastModifiedDesc ? '0.9' : '0.3'" />
                        </th>
                        <th msResponsiveTableColumn="actions" [priority]="1" class="fixed-header" scope="col">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Table Row Start -->
                    @for (schedule of displayPropertyChargeSchedules; let i= $index; track schedule.propertyChargeScheduleId) {
                    <tr class="align-middle" [className]="(i % 2 === 0)? 'even' : 'odd'">
                        <td msResponsiveTableColumn="checkbox" [priority]="1">
                            <input id="toggleSelection" type="checkbox" #toggleSelection class="form-check-input"
                                [value]="schedule.propertyChargeScheduleId"
                                [checked]="selectionItems() | itemSelection: schedule.propertyChargeScheduleId: isSelectAll"
                                (click)="selectionClicked({id: schedule.propertyChargeScheduleId, checked: toggleSelection.checked})" />
                        </td>
                        <td msResponsiveTableColumn="name" [priority]="1">
                            <div class="fw-bold text-truncate" [class.placeholder]="isLoading"
                                [msTooltip]="schedule.name" msTooltipOnlyIfTruncated>
                                {{ schedule.name | noValue }}
                            </div>
                        </td>
                        <td msResponsiveTableColumn="properties" [priority]="3" class="numeric-column">
                            <span [class.placeholder]="isLoading">{{ schedule.propertiesCount | number }}</span>
                        </td>
                        <td msResponsiveTableColumn="amount" [priority]="2" class="numeric-column">
                            <span [class.placeholder]="isLoading">{{ schedule.scheduledAmount | CurrencyDisplay: schedule.scheduledCurrency| noValue}}</span>
                        </td>
                        <td msResponsiveTableColumn="frequency" [priority]="4">
                            <span [class.placeholder]="isLoading">{{ schedule.frequency | scheduleFrequency: schedule.customFrequencyMonths }}</span>
                        </td>
                        <td msResponsiveTableColumn="lateInvoices" [priority]="5" class="numeric-column">
                            <span [class.placeholder]="isLoading">{{ schedule.lateChargesCount | number | noValue }}</span>
                        </td>
                        <td msResponsiveTableColumn="chargeStatus" [priority]="6">
                            <ms-status-badge [isLoading]="isLoading" [status]="schedule.status"></ms-status-badge>
                        </td>
                        <td msResponsiveTableColumn="modified" [priority]="7">
                            <span [class.placeholder]="isLoading">{{ schedule.lastModified | orgDate}}</span>
                        </td>
                        <td msResponsiveTableColumn="actions" [priority]="1">
                            <div class="dropdown"
                                [msCloseMenuOnSettle]="downloadingScheduleId() === schedule.propertyChargeScheduleId">
                                <button class="btn btn-sm btn-ms-secondary dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                    [class.placeholder]="isLoading">
                                    Actions
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                    <li>
                                        <a class="dropdown-item" [routerLink]="['/invoice-schedules/summary/', schedule.propertyChargeScheduleId]">
                                            <fa-duotone-icon icon="clipboard-list" secondaryOpacity="0.3" class="me-2" />Summary
                                        </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" [disableWithoutPermission]="{
                                                requiredPermissions: [BalancesPermissions.Update],
                                                userPermissionOnly: false
                                            }"
                                            [forceDisabled]="schedule.status === PropertyStatuses.Deleted"
                                            [routerLink]="['/invoice-schedules/edit/', schedule.propertyChargeScheduleId]">
                                            <fa-duotone-icon icon="pen-to-square" secondaryOpacity="0.9" class="me-2" />Edit
                                        </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" [class.disabled]="isAnyDownloadInProgress()"
                                            [attr.aria-disabled]="isAnyDownloadInProgress() ? 'true' : null"
                                            [attr.tabindex]="isAnyDownloadInProgress() ? -1 : null"
                                            msDebounceClick
                                            (msDebounceClick)="$event.stopPropagation();
                                                downloadSingleScheduleInvoiceData(schedule.propertyChargeScheduleId)">
                                            @if (downloadingScheduleId() === schedule.propertyChargeScheduleId) {
                                            <span class="spinner-border spinner-border-sm me-2" role="status"></span>Downloading...
                                            } @else {
                                            <fa-duotone-icon icon="download" secondaryOpacity="0.9" class="me-2" />Download Invoice Data
                                            }
                                        </a>
                                    </li>
                                    @if (schedule.status === PropertyStatuses.Active) {
                                    <li>
                                        <a class="dropdown-item" [disableWithoutPermission]="{
                                                requiredPermissions: [BalancesPermissions.Status],
                                                userPermissionOnly: false
                                            }"
                                            (click)="openDeactivateConfirmationModal(schedule)">
                                            <fa-duotone-icon icon="ban" class="me-2" />Deactivate
                                        </a>
                                    </li>
                                    } @else if (schedule.status === PropertyStatuses.Inactive) {
                                    <li>
                                        <a class="dropdown-item" [disableWithoutPermission]="{
                                                requiredPermissions: [BalancesPermissions.Status],
                                                userPermissionOnly: false
                                            }"
                                            (click)="openReactivateModal(schedule)">
                                            <fa-duotone-icon icon="power-off" secondaryOpacity="0.9" class="me-2" />Reactivate
                                        </a>
                                    </li>
                                    }
                                    <li>
                                        <a class="dropdown-item" [disableWithoutPermission]="{
                                                requiredPermissions: [BalancesPermissions.CreateChargeSchedules],
                                                userPermissionOnly: false
                                            }"
                                            [forceDisabled]="schedule.status === PropertyStatuses.Deleted"
                                            (click)="openDeleteScheduleModal(schedule)">
                                            <fa-duotone-icon icon="trash" secondaryOpacity="0.9" class="me-2" />Delete
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                    }
                    <!-- Table Row End -->
                </tbody>
                <tfoot ms-pagination [take]="take" (loadMoreInView)="loadMoreInView()" [(skip)]="skip"
                    [hasNext]="hasNext" [itemCount]="displayPropertyChargeSchedules.length" (jumpToClicked)="jumpToTop($event)">
                </tfoot>
            </table>
        </div>
        <!-- Table End -->

        <!-- Mobile Cards Start -->
        <div id="mobileTableCards" class="d-block d-sm-none">
            @for (schedule of displayPropertyChargeSchedules; let i= $index; track schedule.propertyChargeScheduleId) {

            <div class="card d-flex pt-1 d-inline d-sm-none my-3"
                [msCloseMenuOnSettle]="downloadingScheduleId() === schedule.propertyChargeScheduleId">

                <div class="d-flex flex-column card-body">

                    <div class="d-flex flex-row">
                        <div class="card-left-column d-block-flex text-center">
                            <ms-mobile-card-checkbox [item]="schedule" [selectionPrimaryKey]="SelectionPrimaryKeys.PropertyChargeScheduleId"
                                [isSelected]="selectionItems() | itemSelection: schedule.propertyChargeScheduleId: isSelectAll"
                                (clicked)="selectionClicked($event)" [checkboxSize]="'md'" [checkboxShape]="'circle'" />

                                <ms-status-badge [status]="schedule.status" [isLoading]="isLoading"></ms-status-badge>
                        </div>

                        <div class="right-card-column w-100">
                            <h5 class="card-title-nowrap" [class.placeholder]="isLoading">{{schedule.name}}</h5>
                            
                            <div class="card-text card-text-wrap" [class.placeholder]="isLoading">
                                <span class="fw-semibold">Frequency:</span> {{ schedule.frequency | scheduleFrequency: schedule.customFrequencyMonths }}
                            </div>
                            
                            <div class="card-text" [class.placeholder]="isLoading">
                                <span class="fw-semibold">Modified:</span> {{ schedule.lastModified | orgDate}}
                            </div>
                            
                        </div>
                        
                        <div class="far-right-column fw-bold text-nowrap text-primary">
                            <fa-duotone-icon size="xl" icon="house-chimney" secondaryOpacity="0.3" class="me-2" /> {{schedule.propertiesCount | number}}
                        </div>
                        
                    </div>
                    <div class="text-end text-success fs-5 fw-bold" [class.placeholder]="isLoading">
                        {{ schedule.scheduledAmount | CurrencyDisplay: schedule.scheduledCurrency | noValue}}
                    </div>
                </div>

                <button class="mobile-action-button dropdown-toggle" data-bs-toggle="dropdown"
                    [class.placeholder]="isLoading">
                    Actions
                </button>
                <ul class="dropdown-menu dropdown-menu-end w-75">
                    <li>
                        <a class="dropdown-item" [routerLink]="['/invoice-schedules/summary/', schedule.propertyChargeScheduleId]">
                            <fa-duotone-icon icon="clipboard-list" secondaryOpacity="0.3" class="me-2" />Summary
                        </a>
                    </li>
                    <li>
                        <a class="dropdown-item" [disableWithoutPermission]="{
                                requiredPermissions: [BalancesPermissions.Update],
                                userPermissionOnly: false
                            }"
                            [forceDisabled]="schedule.status === PropertyStatuses.Deleted"
                            [routerLink]="['/invoice-schedules/edit/', schedule.propertyChargeScheduleId]">
                            <fa-duotone-icon icon="pen-to-square" secondaryOpacity="0.9" class="me-2" />Edit
                        </a>
                    </li>
                    <li>
                        <a class="dropdown-item" [class.disabled]="isAnyDownloadInProgress()"
                            [attr.aria-disabled]="isAnyDownloadInProgress() ? 'true' : null"
                            [attr.tabindex]="isAnyDownloadInProgress() ? -1 : null"
                            msDebounceClick
                            (msDebounceClick)="$event.stopPropagation();
                                downloadSingleScheduleInvoiceData(schedule.propertyChargeScheduleId)">
                            @if (downloadingScheduleId() === schedule.propertyChargeScheduleId) {
                            <span class="spinner-border spinner-border-sm me-2" role="status"></span>Downloading...
                            } @else {
                            <fa-duotone-icon icon="download" secondaryOpacity="0.9" class="me-2" />Download Invoice Data
                            }
                        </a>
                    </li>
                    @if (schedule.status === PropertyStatuses.Active) {
                    <li>
                        <a class="dropdown-item" [disableWithoutPermission]="{
                                requiredPermissions: [BalancesPermissions.Status],
                                userPermissionOnly: false
                            }"
                            (click)="openDeactivateConfirmationModal(schedule)">
                            <fa-duotone-icon icon="ban" class="me-2" />Deactivate
                        </a>
                    </li>
                    } @else if (schedule.status === PropertyStatuses.Inactive) {
                    <li>
                        <a class="dropdown-item" [disableWithoutPermission]="{
                                requiredPermissions: [BalancesPermissions.Status],
                                userPermissionOnly: false
                            }"
                            (click)="openReactivateModal(schedule)">
                            <fa-duotone-icon icon="power-off" secondaryOpacity="0.9" class="me-2" />Reactivate
                        </a>
                    </li>
                    }
                    <li>
                        <a class="dropdown-item" [disableWithoutPermission]="{
                                requiredPermissions: [BalancesPermissions.CreateChargeSchedules],
                                userPermissionOnly: false
                            }"
                            [forceDisabled]="schedule.status === PropertyStatuses.Deleted"
                            (click)="openDeleteScheduleModal(schedule)">
                            <fa-duotone-icon icon="trash" secondaryOpacity="0.9" class="me-2" />Delete
                        </a>
                    </li>
                </ul>
            </div>
            }
            <div ms-in-view-port (inViewPort)="loadMoreInView()" ms-pagination [take]="take" [(skip)]="skip"
                [hasNext]="hasNext" [itemCount]="displayPropertyChargeSchedules.length" (jumpToClicked)="jumpToTop($event)">
            </div>

        </div>
        <!-- Mobile Cards End -->

        <ms-confirmation-modal #propertyChargeScheduleListConfirmationModalRef modalId="propertyChargeScheduleListConfirmationModal"
            confirmButtonText="Confirm"
            (confirmed)="onDeactivateConfirmed()"
            (cancelled)="onDeactivateCancelled()" />

        <ms-info-modal #propertyChargeScheduleListInfoModalRef modalId="propertyChargeScheduleListInfoModal" />

        <ms-delete-invoice-schedule-modal
            #deleteInvoiceScheduleModalRef
            (deleteCompleted)="onScheduleDeleted()" />

        <ms-reactivate-invoice-schedule-modal
            #reactivateInvoiceScheduleModalRef
            (reactivateCompleted)="onScheduleReactivated()" />
    </div>
</div>
